

import { Box, Theme, Typography } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import * as React from 'react';
const useStyles = makeStyles((theme: Theme) => createStyles({
  Title: {
    display: 'flex',
    flexDirection:'row',
    alignItems:'center',
   
  },
  left:{

    width:'3px',
    height:'29px',
    background:'red',

  },
  right:{
    color:'black',
    fontWeight:'500',
    fontSize:'25px',
    paddingLeft:'20px'
  }
  
  
}));

export default function Title ({name}) {
  const classes = useStyles();

  return (
    <Box className={classes.Title}>
      <Box className={classes.left}>
      </Box>
      <Typography className={classes.right}>
          {name}
      </Typography >
    </Box>
  );
}